"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _classnames = _interopRequireDefault(require("classnames"));

var _hover = require("../../../hooks/hover");

var _Popper = _interopRequireDefault(require("@material-ui/core/Popper"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _ClickAwayListener = _interopRequireDefault(require("@material-ui/core/ClickAwayListener"));

require("./Label.css");

var View = function View(_ref, ref) {
  var id = _ref.id,
      name = _ref.name,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$unread = _ref.unread,
      unread = _ref$unread === void 0 ? 0 : _ref$unread,
      _ref$invert = _ref.invert,
      invert = _ref$invert === void 0 ? false : _ref$invert,
      isActive = _ref.isActive,
      onClick = _ref.onClick,
      _ref$moreAction = _ref.moreAction,
      moreAction = _ref$moreAction === void 0 ? {} : _ref$moreAction,
      _ref$isDragOver = _ref.isDragOver,
      isDragOver = _ref$isDragOver === void 0 ? false : _ref$isDragOver;

  var _useHover = (0, _hover.useHover)(),
      hovered = _useHover.hovered,
      targetProps = _useHover.targetProps;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setOpen = _useState2[1];

  var dropdownRef = (0, _react.useRef)(null);
  var validatedAction = !((0, _isNil["default"])(moreAction) || (0, _isEmpty["default"])(moreAction));
  var colorNode = (0, _react.useMemo)(function () {
    return (0, _isNil["default"])(color) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null) : /*#__PURE__*/_react["default"].createElement("div", {
      className: "w-1 h-8 mr-5",
      style: {
        backgroundColor: color
      }
    });
  }, [color]);
  var unreadNode = (0, _react.useMemo)(function () {
    if ((validatedAction ? !hovered : true) && !isOpen && !!unread) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('text-xs font-normal pl-3', {
          '!text-white': isDragOver
        }),
        style: unread < 10 ? {
          marginRight: '.5ch'
        } : {}
      }, unread.toLocaleString());
    } else {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
    }
  }, [validatedAction, hovered, isOpen, unread, isDragOver]);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    ref: ref,
    className: (0, _classnames["default"])('text-md font-light cursor-pointer', 'select-none -mx-6 flex items-center hover:opacity-100', {
      'bg-gray-light dark:bg-secondary !text-white': isDragOver
    }, {
      'font-semibold': isActive,
      'opacity-75 hover:opacity-100': !isActive,
      'text-dark dark:text-white': !invert
    }, {
      'active:Navigation-Label-invert !text-white': invert && isActive,
      'hover:Navigation-Label-invert force-light:text-ultra-light hover:text-white': invert && !isActive,
      'bg-secondary': !invert && isActive,
      'hover:bg-ultra-light': !invert && !isActive
    })
  }, targetProps), colorNode, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mr-6 flex flex-1 justify-between items-center min-w-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "py-2 flex flex-1 items-center justify-between min-w-0",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate"
  }, name), unreadNode), validatedAction && /*#__PURE__*/_react["default"].createElement(_ClickAwayListener["default"], {
    onClickAway: isOpen ? function () {
      return setOpen(false);
    } : _noop["default"]
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: dropdownRef
  }, (hovered || isOpen) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-gray-light",
    style: {
      marginRight: '-0.6ch'
    }
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "inherit",
    size: "small",
    onClick: function onClick() {
      return setOpen(!isOpen);
    }
  }, moreAction.trigger)), /*#__PURE__*/_react["default"].createElement(_Popper["default"], {
    open: isOpen,
    anchorEl: dropdownRef.current,
    placement: "bottom-start",
    className: "z-50"
  }, moreAction.node)))));
};

View.displayName = 'Label';

var _default = /*#__PURE__*/(0, _react.forwardRef)(View);

exports["default"] = _default;
//# sourceMappingURL=Label.js.map